import type * as React from 'react';
import { css } from '@emotion/react';
import { theme } from '@Guidelines/Theme/theme';

const pageStyle = css`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	background-color: ${theme.colors.canvas};
`;

type Props = {
	className?: string;
	children: React.ReactNode;
};

const RootPage: React.FC<Props> = ({ children, className }) => {
	return (
		<div css={pageStyle} className={className}>
			{children}
		</div>
	);
};

export default RootPage;
